import { useMarkToolbarButton, useMarkToolbarButtonState } from "platejs/react";
import { memo, type ReactNode } from "react";
import { ToolbarButton } from "./toolbar";

export interface MarkToolbarButtonProps {
  nodeType: string;
  tooltip: string;
  clear?: string | string[];
  children: ReactNode;
}

export const MarkToolbarButton = memo(function MarkToolbarButton({
  nodeType,
  tooltip,
  clear,
  children,
}: MarkToolbarButtonProps) {
  const state = useMarkToolbarButtonState({ clear, nodeType });
  const { props } = useMarkToolbarButton(state);

  return (
    <ToolbarButton tooltip={tooltip} {...props}>
      {children}
    </ToolbarButton>
  );
});
